import AddCollege from "../../Components/Modals/AddCollege";
import Table from "../../Components/Table";
import { deleteCollegeById, getAllCollegePagination } from "../../Services/MasterService";

const College = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "City",
            value: "city_name"
        },
        {
            label: "Title",
            value: "title"
        },
        {
            label: "Description",
            value: "description"
        },
        {
            label: "Establish Year",
            value: "establish_year"
        },
        {
            label: "Gender Preference",
            value: "gender_preference"
        },
        {
            label: "Institution Type",
            value: "institutuion_type"
        },
        {
            label: "Campus Size",
            value: "campus_size"
        },
        {
            label: "Student Count",
            value: "student_count"
        },
        {
            label: "Parent Name",
            value: "parent_name"
        },
        {
            label: "International Student (%)",
            value: "percent_international_student"
        },
        {
            label: "Acceptance Ratio",
            value: "acceptance_ratio"
        },
        {
            label: "Cost Of Living",
            value: "avg_cost_living"
        },
        {
            label: "Rank",
            value: "college_rank"
        },
        {
            label: "Description",
            value: "description"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCollege data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCollegePagination}
            columns={columns}
            title={"College Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCollegeById}
        />
    );
}

export default College;